import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import ServiceAvailabilityActions from '../reducers/serviceAvailabilityReducer'

export function* getServiceAvailability() {
  try {
    const collection = firebase
      .firestore()
      .collection('service_availability')
      .orderBy('active', 'desc')
      .orderBy('created_at')

    const snapshot = yield call([collection, collection.get])

    const data = {}

    snapshot.forEach(doc => {
      const snapshotData = doc.data()

      data[doc.id] = { ...snapshotData, id: doc.id }
    })

    yield put(ServiceAvailabilityActions.setServiceAvailability(data))
  } catch (error) {
    yield put(ServiceAvailabilityActions.setServiceAvailability({}))
  }
}


// WEBPACK FOOTER //
// ./src/sagas/serviceAvailabilitySaga.js